<div class="driver-list" *ngIf="hasDrivers">
  <span class="driver-list__heading">{{ heading }}</span>
  <div class="driver-list__row" *ngFor="let driver of drivers; trackBy: trackByLabel">
    <span class="driver-list__label">{{ driver.label }}</span>
    <span class="driver-list__share">{{ driver.share }}</span>
  </div>
</div>
